import type { SWRConfiguration } from 'swr';

/** Shared options for paginated cabinet lists (keep rows visible while the next page loads). */
export const swrPaginatedListConfig: SWRConfiguration = {
  keepPreviousData: true,
};
